(function () {
  if (window.__galeriaSlideFix) return;
  window.__galeriaSlideFix = true;

  /* Devuelve el lugar REAL de una foto dentro de la galeria (sin contar los
     slides duplicados que Swiper agrega para el carrusel infinito). */
  function indiceDe(galeria, mediaId) {
    var slides = Array.prototype.slice.call(
      galeria.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')
    );
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].dataset.mediaId) === String(mediaId)) return i;
    }
    return -1;
  }

  function slider(galeria) {
    return galeria && galeria.sliderInstance && galeria.sliderInstance.slider;
  }

  function parchar() {
    var Gallery = window.customElements && customElements.get('media-gallery');
    if (!Gallery || Gallery.prototype.__slideFix) return false;
    Gallery.prototype.__slideFix = true;

    /* Al cambiar de color/cantidad el tema hacia slideToLoop(position - 1),
       donde `position` es el lugar de la foto entre TODAS las del producto
       (176 en Pachoncito 200), pero la galeria solo pinta las del color
       elegido. Ese numero apuntaba fuera de rango y siempre caia en el
       ultimo slide (la textura). Aqui se busca el slide por su id. */
    Gallery.prototype.setActiveMedia = function (variant) {
      if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;
      var sl = slider(this);
      if (sl) {
        var i = indiceDe(this, variant.featured_media.id);
        sl.slideToLoop(i >= 0 ? i : 0);
      } else {
        this.sortMediaItems(variant);
      }
    };
    return true;
  }

  /* Las miniaturas traen data-media-position (2 y 3 en Pachoncito 200) pero
     solo existen 2 slides, asi que el tema las mandaba fuera de rango.
     OJO: en esta version de Swiper `realIndex` se queda pegado y no sirve
     para comparar, por eso se reposiciona siempre. */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.product__thumbs-item');
    if (!thumb) return;
    var galeria = thumb.closest('media-gallery');
    var sl = slider(galeria);
    if (!sl) return;
    var i = indiceDe(galeria, thumb.dataset.target);
    if (i < 0) return;
    setTimeout(function () { sl.slideToLoop(i); }, 0);
  }, true);

  if (!parchar()) {
    document.addEventListener('DOMContentLoaded', parchar);
    window.addEventListener('load', parchar);
  }
})();
